import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmptyState } from 'breeze-intelligence-kit';
import { useEnrichmentProperties } from './useEnrichmentProperties';
import { ILLUSTRATION_SIZE } from '../../constants';
import { useEnrichableObjectTypes } from '../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Title = styled.div.withConfig({
  displayName: "EnrichmentPropertiesEmpty__Title",
  componentId: "sc-1ims71k-0"
})(["font-size:1rem;font-weight:500;line-height:1.5;max-inline-size:45ch;"]);
export const EnrichmentPropertiesEmpty = () => {
  const {
    isContactEnrichment
  } = useEnrichmentProperties();
  const {
    companyLabelLowercase,
    contactLabelLowercase
  } = useEnrichableObjectTypes();
  const Message = () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "enrichmentProperties.panel.empty",
    options: {
      objectType: isContactEnrichment ? contactLabelLowercase : companyLabelLowercase
    }
  });
  return /*#__PURE__*/_jsxs(EmptyState, {
    gap: "space-xl",
    marginBlock: "space-xxxl",
    paddingBlock: "space-xxxl",
    children: [/*#__PURE__*/_jsx(EmptyState.Illustration, {
      height: ILLUSTRATION_SIZE,
      name: "success-greyscale",
      width: ILLUSTRATION_SIZE
    }), /*#__PURE__*/_jsx(Title, {
      children: /*#__PURE__*/_jsx(Message, {})
    })]
  });
};